import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {
    ADD_SELECTED_SELLERS,REMOVE_SELECTED_SELLERS  }  from "actions/actionTypes";
import config from  '../../../config';
import {Link} from 'react-router';
import {customTableSelect,customFormatter,dateFormatter, actionsFormatter} from 'util/Utils';
class AdminSellerListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            perPage: config.table.numberPerPage
        };
    }
    customActionsFormatter(cell, row, extra) {
        var menuItemsMap = []
         if (config.checkAccessRights.call(this,{ resources:['sellers_edit']})) {
            menuItemsMap.push( {onClick: 'editSeller', label: 'Edit'})
        }
        if (config.checkAccessRights.call(this,{ resources:['sellers_edit']}) &&_.get(row, 'UserID.ShopifyCustomerID')) {
            menuItemsMap.push({
                onClick: function () {
                    window.open(config.getEnvironment().clientSideURL + '/client/schedule-pickup?customerid=' + _.get(row, 'UserID.ShopifyCustomerID' ) + '&administratorMode=true', "_blank")

                }, label: 'Add service'
            })
        }
        return actionsFormatter.call(this, cell, row, {menuItemsMap})
    }
    onRowSelect(row, isSelected, e) {
         var actionName =   isSelected ? ADD_SELECTED_SELLERS : REMOVE_SELECTED_SELLERS;
         this.props.dispatchAction([row], actionName)
    }
    onAllRowSelect(isSelected, rows){
        var actionName =   isSelected ? ADD_SELECTED_SELLERS : REMOVE_SELECTED_SELLERS;
        this.props.dispatchAction(rows, actionName)
    }
    customMultiSelect(props) {
       return customTableSelect(props, {table:this.refs.table, selectedRows:this.props.adminSellers.selectedSellers});
    }


    sellerProductsLinkFormatter(cell, row, extra) {
        if (config.checkAccessRights.call(this,{ resources:['sellers_edit']})) {
            return (
                <Link className=" underlineText" target="_blank"
                      to={'/admin/products?SellerID=' + encodeURIComponent(row._id)}>{row['UserID'] ? row['UserID']['firstName'] : ''}</Link>
            );
        }else {
            return <span>{row['UserID'] ? row['UserID']['firstName'] : ''}</span>

        }
    }

    editSeller(row) {
        window.open(config.getEnvironment().clientSideURL+`/admin/seller/${encodeURIComponent(row._id)}/edit`, "_blank")
    }
    editSellerLinkFormatter(cell, row, extra) {
        if (config.checkAccessRights.call(this,{ resources:['sellers_edit']})) {
            return (
                <Link className=" underlineText" target="_blank"
                      to={'/admin/seller/'+encodeURIComponent(row._id)+'/edit'}>{ row['SellerNumber'] }</Link>
            );
        }else {
            return <span>{row['UserID'] ? row['UserID']['firstName'] : ''}</span>
        }
    }
    extraFormatter(cell, row, extra) {
        return row.UserID ? row.UserID[extra] : ''
    }

    render() {
        const  selectRowProp = {
            mode: 'checkbox',
            columnWidth: '29px',
            onSelect: this.onRowSelect.bind(this),
            onSelectAll: this.onAllRowSelect.bind(this),
            customComponent: this.customMultiSelect.bind(this)
        }

        return (
            <div className="panel panel-default">
                <div className=" databases-table">
                    <BootstrapTable ref='table'
                                    data={this.props.adminSellers.data}
                                    selectRow={ selectRowProp }
                                    remote={true}
                                    hover={true}
                                    condensed={true}
                                    striped={true}
                                    options={ {
                                        ...config.bootstrapTableOptions,
                                        onSortChange: this.props.onSortChange
                                    } } >
                        <TableHeaderColumn width="20px"  dataAlign="center" dataField="SellerNumber"  dataSort={true}  dataFormat={ this.editSellerLinkFormatter.bind(this) }   >#</TableHeaderColumn>
                        <TableHeaderColumn width="30px"   dataAlign="center"  dataFormat={ this.sellerProductsLinkFormatter.bind(this) }
                                           dataField="firstName"  dataSort={true}  >First Name</TableHeaderColumn>
                        <TableHeaderColumn width="0px"  dataField="_id" isKey={true} hidden={true}
                                           autoValue={ true } hiddenOnInsert>Id</TableHeaderColumn>
                        <TableHeaderColumn width="40px"  dataAlign="center" dataFormat={ this.extraFormatter }
                                           formatExtraData={ 'lastName' }
                                           dataField="lastName"  dataSort={true}   columnClassName={'break-word'}   >Last Name</TableHeaderColumn>
                        <TableHeaderColumn width="60px" dataFormat={ this.extraFormatter }
                                           formatExtraData={ 'email' }    dataAlign="center"  columnClassName={'break-word'}  dataField="email"  dataSort={true} >Email</TableHeaderColumn>
                        <TableHeaderColumn width="40px"  dataAlign="center" dataField='DisplayName'
                                           dataSort={true}>Display Name</TableHeaderColumn>
                        <TableHeaderColumn width="40px"  dataAlign="center" dataField='MarketName'
                                           dataSort={true}>Location</TableHeaderColumn>
                        {/*<TableHeaderColumn        dataAlign="center"  width="20px" dataField='ServicesTotalNumber'*/}
                                           {/*dataFormat={ customFormatter }*/}
                                           {/*formatExtraData={ {*/}
                                               {/*path: ['ServicesTotalNumber'],*/}
                                               {/*format: (value) => {*/}
                                                    {/*if ( value >0) {*/}
                                                       {/*return  value*/}
                                                   {/*} else {*/}
                                                       {/*return ''*/}
                                                   {/*}*/}
                                               {/*}}}*/}
                                           {/*dataSort={true}>#Services</TableHeaderColumn>*/}
                        {/*<TableHeaderColumn         dataAlign="center"  width="20px" dataField='PickupsTotalNumber'*/}
                                                   {/*dataFormat={ customFormatter }*/}
                                                   {/*formatExtraData={ {*/}
                                                       {/*path: ['PickupsTotalNumber'],*/}
                                                       {/*format: (value) => {*/}
                                                            {/*if ( value >0) {*/}
                                                               {/*return  value*/}
                                                           {/*} else {*/}
                                                               {/*return ''*/}
                                                           {/*}*/}
                                                       {/*}}}*/}
                                                   {/*dataSort={true}>#Pickup</TableHeaderColumn>*/}
                        {/*<TableHeaderColumn         dataAlign="center"  width="20px" dataField='DropoffsTotalNumber'*/}
                                                   {/*dataFormat={ customFormatter }*/}
                                                   {/*formatExtraData={ {*/}
                                                       {/*path: ['DropoffsTotalNumber'],*/}
                                                       {/*format: (value) => {*/}
                                                            {/*if ( value >0) {*/}
                                                               {/*return  value*/}
                                                           {/*} else {*/}
                                                               {/*return ''*/}
                                                           {/*}*/}
                                                       {/*}}}*/}
                                                   {/*dataSort={true}>#Dropoff</TableHeaderColumn>*/}

                        {/*<TableHeaderColumn   dataAlign="center"  width="20px" dataField='ProductsTotalNumber'*/}
                                                   {/*dataFormat={ customFormatter }*/}
                                                   {/*formatExtraData={ {*/}
                                                       {/*path: ['ProductsTotalNumber'],*/}
                                                       {/*format: (value) => {*/}
                                                            {/*if ( value >0) {*/}
                                                               {/*return  value*/}
                                                           {/*} else {*/}
                                                               {/*return ''*/}
                                                           {/*}*/}
                                                       {/*}}}*/}
                                                   {/*dataSort={true}>#Products Listed</TableHeaderColumn>*/}
                        {/*<TableHeaderColumn   dataAlign="center"  width="40px" dataField='ProductsTotalSum'*/}
                                             {/*dataFormat={ customFormatter }*/}
                                             {/*formatExtraData={ {*/}
                                                 {/*path: ['ProductsTotalSum'],*/}
                                                 {/*format: (value) => {*/}
                                                     {/*if (value == ''){*/}
                                                         {/*return*/}
                                                     {/*}*/}
                                                     {/*if ( value >=0) {*/}
                                                         {/*return  '$'+value.toFixed(2)*/}
                                                     {/*} else {*/}
                                                         {/*return   '-$'+Math.abs(value.toFixed(2))*/}
                                                     {/*}*/}
                                                 {/*}}}*/}
                                             {/*dataSort={true}>Value of items</TableHeaderColumn>*/}
                        {/*<TableHeaderColumn   dataAlign="center"  width="40px" dataField='SellerTotalMade'*/}
                                             {/*dataFormat={ customFormatter }*/}
                                             {/*formatExtraData={ {*/}
                                                 {/*path: ['SellerTotalMade'],*/}
                                                 {/*format: (value) => {*/}
                                                     {/*if (value == ''){*/}
                                                         {/*return*/}
                                                     {/*}*/}
                                                     {/*if ( value >=0) {*/}
                                                         {/*return  '$'+value.toFixed(2)*/}
                                                     {/*} else {*/}
                                                         {/*return   '-$'+Math.abs(value.toFixed(2))*/}
                                                     {/*}*/}
                                                 {/*}}}*/}
                                             {/*dataSort={true}>Money Made</TableHeaderColumn>*/}
                        {/*<TableHeaderColumn         dataAlign="center"  width="20px" dataField='SaleTransactionsTotalNumber'*/}
                                                   {/*dataFormat={ customFormatter }*/}
                                                   {/*formatExtraData={ {*/}
                                                       {/*path: ['SaleTransactionsTotalNumber'],*/}
                                                       {/*format: (value) => {*/}
                                                           {/*console.log('value', value  );*/}
                                                           {/*if ( value >0) {*/}
                                                               {/*return  value*/}
                                                           {/*} else {*/}
                                                               {/*return ''*/}
                                                           {/*}*/}
                                                       {/*}}}*/}
                                                   {/*dataSort={true}>#Sale transactions</TableHeaderColumn>*/}
                        {/*<TableHeaderColumn         dataAlign="center"  width="30px" dataField='FirstServiceDate'*/}
                                                   {/*columnClassName={'break-word'}*/}
                                                   {/*dataFormat={ dateFormatter }*/}
                                                   {/*formatExtraData={ {'name': 'FirstServiceDate', 'format': 'MM-DD YYYY'} }*/}
                                                   {/*dataSort={true}>First Service Date</TableHeaderColumn>*/}
                        {/*<TableHeaderColumn         dataAlign="center"  width="30px" dataField='LastServiceDate'*/}
                                                   {/*columnClassName={'break-word'}*/}
                                                   {/*dataFormat={ dateFormatter }*/}
                                                   {/*formatExtraData={ {'name': 'LastServiceDate', 'format': 'MM-DD YYYY'} }*/}
                                                   {/*dataSort={true}>Last Service Date</TableHeaderColumn>*/}
                        <TableHeaderColumn
                                            columnClassName={'actions-column'}
                                            dataFormat={ this.customActionsFormatter.bind(this) }
                                           dataAlign="center"         ></TableHeaderColumn>
                    </BootstrapTable>
                </div>
            </div>

        );
    }
}


export default AdminSellerListTable;
